import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SearchResultsListComponent, LoadingScreen } from 'gigi-component-library';
import { SearchResultTranslation } from './SearchResultTranslation';
import { BrandedFareAPI, GetPromoCode } from 'gigi-api-layer';
import { updateSelectedBrandedFareId, updateBrandedFaresData, updateSelectedItineraryFare, updatePricingData } from '../../redux/actions/brandedFare';
import { ROUTES } from '../../utility/constants';
import {ErrorNotifier, ErrorHandler} from 'gigi-component-library';
import UpliftInitResult from '../Uplift/upliftInitResult';
import { setSearchResultHit } from '../../redux/actions/search';
import { DTM_STATUS, EVENT_TYPES, TRACKING_DATA, trackEvent } from '../../utility/TrackingRules';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';

declare global {
    interface Window {
      _satellite?: {
        track: (eventName: string,data: any) => void;
      };
    }
  }

const AllSearchResults = () => {
    const searchResults = useSelector((state: any) => state.search.searchResults);
    const searchRequest = useSelector((state: any) => state.search.searchRequest);
    const isLoading = useSelector((state: any) => state.search.searchIsLoading);
    const triptype = useSelector((state: any) => state.search.tripType);
    const brandFareData = useSelector((state:any)=>state.brandedFares.brandedFareResult);
    const correlationId = useSelector((state: any) => state.search.correlationId);
    const searchResultApiHit = useSelector((state:any)=>state.search.searchClicked);
    const providerConfig = useSelector((state: any) => state.languageChange.provider);
    const [outboundData, setOutboundData]: any = useState([]);
    const [inboundData, setInboundData]: any = useState([]);
    const [searchResultsData, setSearchResultsData] = useState<SearchResultTranslation | null>(null);
    const [brandedFaresResultsAPI, brandedFaresResults, brandedFaresInProgress, brandedFaresError]= BrandedFareAPI();
    const [version, setVersion] = useState(0); // version state to trigger re-render
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const TripInfoData = useSelector((state: any) => state.tripInfoResult.uplift);
    const language = useSelector((state: any) => state.languageChange.language);
    const location = useLocation();
    const {UPLIFT_CONFIG = {}, PROMO_CONFIG = {}} = process.env;
    const [getPromoCode, promoCodeResults, promoCodeInProgress, promoCodeError] = GetPromoCode();
    const [fareIDInfo, setFareID] = useState<any>("");
    
    const [displayFlightMatrix,setdisplayFlightMatrix] = useState(true);
    const handleApplyPromo = async (payload) => {
        getPromoCode(payload, correlationId)
    }

    useEffect(() => {
        if(searchResults?.faresOptions?.length > 0 ){
            const allSearchResults = new SearchResultTranslation(searchResults, searchRequest?.passengers);
            setSearchResultsData(allSearchResults);   
            dispatch(setSearchResultHit(false))
            let flights = searchResults?.flights?.map(({operatingCarrier = "", number}) => ({ productId: `${operatingCarrier}${number}`, impressionType: "standard", discounted: "na"}));
            trackEvent(EVENT_TYPES.PRODUCT_IMPRESSION, flights);
        }else{
            if(!isLoading && searchResultApiHit){
                dispatch(setSearchResultHit(false))
                ErrorHandler('No Search Result Found', 'No search result found for your search. Please change some parameters and try again',null ,  'Ok',  'warning','alertModal');
                trackEvent(EVENT_TYPES.MODAL_POPUP_ERRORS, { path:'flight', error:'No Search Result Found'});
            }
            setSearchResultsData(null)
        }
        dispatch(updateBrandedFaresData([]))
    }, [searchResults]);

    const setNextLevel = (refId:any, index?:number) => {
        if (searchResultsData) {
            setdisplayFlightMatrix(true);
            if(index != 0 || index == undefined){
                setdisplayFlightMatrix(false);
            }
           
            searchResultsData.setReferenceId = refId
            searchResultsData.setDataLevel = (index || index === 0) ? index : searchResultsData.getCurrentLevel + 1;
            setVersion((prevVersion) => prevVersion + 1); // Update version to force re-render
        }
    };

    function setPricingAPIData(fareID) {
        if (fareID) {
            if (brandFareData?.itineraryFares) {
                const itineraryFaresSelected = brandFareData.itineraryFares.filter(fareId => fareId.id == fareID.fareId)
                dispatch(updateSelectedItineraryFare(itineraryFaresSelected))
            }
            else {
                dispatch(updateSelectedItineraryFare([]))
            }
            dispatch(updateSelectedBrandedFareId({ fareID }))
            const queryParams = new URLSearchParams({ uid: correlationId });
            navigate(`${ROUTES.booking}?${queryParams.toString()}`);
        }
    }

    useEffect(()=>{
        if(brandedFaresInProgress){
            dispatch(updateBrandedFaresData([]))
            dispatch(updatePricingData({}));
        }else{
            dispatch(updateBrandedFaresData(brandedFaresResults));
            if ((brandedFaresResults && (brandedFaresResults.hasOwnProperty('itineraryFares')) && brandedFaresResults.itineraryFares.length == 0)) {
                let obj = {
                    "fareId": fareIDInfo?.fareCode
                }
                setPricingAPIData(obj);
            }
            if ((brandedFaresResults && (!brandedFaresResults.hasOwnProperty('itineraryFares')))) {
                if(brandedFaresResults.hasOwnProperty('MESSAGE')){
                    ErrorHandler('Branded Fares Error', brandedFaresResults.MESSAGE,null ,  'Ok',  'warning','alertModal');
                    trackEvent(EVENT_TYPES.MODAL_POPUP_ERRORS, { path:'flight', error:brandedFaresResults.MESSAGE});
                    trackEvent(EVENT_TYPES.FLIGHT_UPGRADATION, { error: 'true', pid: fareIDInfo });

                }else{
                    ErrorHandler('Branded Fares Error', 'A technical error prevents us from booking',null ,  'Ok',  'warning','alertModal');
                    trackEvent(EVENT_TYPES.MODAL_POPUP_ERRORS, { path:'flight', error:'A technical error prevents us from booking'});
                    trackEvent(EVENT_TYPES.FLIGHT_UPGRADATION, { error: 'true', pid: fareIDInfo });
                }
            }
            
        }
    },[brandedFaresInProgress,brandedFaresResults])
    
    useEffect(() => {
        const queryParams: any = queryString.parse(location.search, { arrayFormat: 'bracket' });
        const legs = queryParams.leg || [];
        let searchOrigin = '';
        let searchDestination = '';
        let searchDaysInAdvance = '';

        if (Array.isArray(legs) && legs.length > 0) {
            const [origin,firstDestination, departureDate] = legs[0].split(';');
            const [, destination, ] = legs[legs?.length - 1 || 0].split(';');
            searchOrigin = origin;
            searchDestination = destination;
            if(searchOrigin === searchDestination){
                searchDestination = firstDestination;
            }
            const today = moment();
            const departure = moment(departureDate, 'YYYY/MM/DD');
            if (departure.isValid()) {
                searchDaysInAdvance = departure.diff(today, 'days').toString();
            }
        }
        let searchTrackData:any = TRACKING_DATA.SEARCH;
        const data = {
            ...searchTrackData,
            digitalData: {
                ...searchTrackData.digitalData,
                page: {
                    ...searchTrackData.digitalData.page,
                    searchOrigin,
                    searchDestination,
                    noOfSearchResults: '',
                    searchDaysInAdvance
                }
            }
        };

        trackEvent(EVENT_TYPES.DOM_READY, data);
    }, []);

    // useEffect(() => {
    //     trackEvent(EVENT_TYPES.PROMO_CODE, DTM_STATUS.SUCCESS)
    // }, [promoCodeResults]);

    // useEffect(() => {
    //     if(promoCodeError){
    //         trackEvent(EVENT_TYPES.PROMO_CODE, DTM_STATUS.FAIL)
    //     }
    // }, [promoCodeError]);

    return (
        <div>
            {isLoading && <LoadingScreen />}
            {!isLoading && searchResultsData && (
                <>
                 {searchRequest!='' && UPLIFT_CONFIG["ENABLE_FEATURE"] ? <UpliftInitResult  />:''} 
                <SearchResultsListComponent
                    key={version} // Use version as key to force re-render
                    getSearchResult={searchResultsData.getCurrentLevelData}
                    inboundData={inboundData}
                    filterData={searchResultsData.allFilterData || {}}
                    ifNextLevelExist={searchResultsData.doesNextLevelExist}
                    setNextLevel={setNextLevel}
                    displayMatrix={displayFlightMatrix}
                    brandedFaresResultsAPI={(fareID) => {setFareID(fareID);brandedFaresResultsAPI(fareID, searchResults.token, correlationId)}}
                    brandedFaresResults={brandFareData}
                    pricingAPI={(fareID) => setPricingAPIData(fareID)}
                    brandedFaresLoader={brandedFaresInProgress}       
                    allReference = {searchResultsData.getReferenceId}
                    dataLevelId = {searchResultsData.getDataLevelIds}
                    triptype={triptype}
                    searchRequest = {searchRequest}
                    TripInfoData = {JSON.parse(JSON.stringify(TripInfoData))}
                    promoconfig={PROMO_CONFIG} 
                    callPromoCodeApI={handleApplyPromo} 
                    promoCodeResults={promoCodeResults} 
                    promoCodeInProgress={promoCodeInProgress}
                    providerConfig={providerConfig}
                    processAmountAsPerPaxCount = {searchResultsData.processAmountAsPerPaxCount}
                    language={language}
                    EVENT_TYPES = {EVENT_TYPES}
                    TRACKING_DATA = {TRACKING_DATA}
                    trackEvent = {trackEvent}
                />
                </>
            )}

            <ErrorNotifier/>
        </div>
    );
};

export default AllSearchResults;
